/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageViewer/PatientImages/AllImages/PatientImage/Content"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let viewerImageIdValueData = fromData.useDataValue({ viewPath,
context: 'viewer',
path: 'image_id',
})
let aggregateData = fromAggregate.equals(patientImageIdValueData, viewerImageIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--soy-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-2-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-Z1Yf8zk': isHovered ? "rgba(111,111,111, 0.1)" : aggregateData ? "rgba(0,188,112, 0.1)" : dtColorsWhite,'--o-4-Z1Yf8zk': aggregateData ? 1 : 0.5}}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 width={60}
 height={60}
 data="resource.preview_url"
 url={resourcePreviewUrlValueData}
/>
</button>
{children}
</React.Fragment>)
}